<template>
  <div class="mc-modal" id="productNotify" :class="{isOpen: isOpen}">
    <div class="mc-modal__outer">
      <div class="mc-modal__inner">
        <div class="mc-modal__heading">
          <button @click="$emit('close')" class="mc-modal__close-button js-button-close simulated-hover" type="button" aria-label="Закрыть">
            <svg class="mc-modal__close-icon" width="30" height="30" viewBox="0 0 30 30">
              <use xlink:href="/assets/svg/sprite.svg#icon-cross"></use>
            </svg>
          </button>
          <div class="mc-modal__title">
            {{submitStatus.success?'Спасибо. Мы сообщим вам о поступлении':'Сообщить о поступлении'}}
          </div>
        </div>
        <div v-if="!submitStatus.success" class="mc-modal__body">
          <form class="mc-form" @submit.prevent="submitForm" autocomplete="off">
            <div class="mc-form__body">
              <fieldset class="mc-form__fieldset">
                <div class="mc-form__field">
                  <label class="mc-form__label" for="productNotifyName">
                    Имя и фамилия
                    <span class="mc-form__asterisk">*</span>
                  </label>
                  <input class="mc-form__input" id="productNotifyName" v-model="formData.name" type="text" name="name" placeholder="Ольга Иванова" required>
                </div>
                <div class="mc-form__field">
                  <label class="mc-form__label" for="productNotifyEmail">
                    Email
                    <span class="mc-form__asterisk">*</span>
                  </label>
                  <input class="mc-form__input" id="productNotifyEmail" v-model="formData.email" type="email" name="email" placeholder="example@email.com" required>
                </div>
              </fieldset>
              <p class="mc-form__notice mc-form__notice--centered">
                Нажимая на кнопку "Отправить", вы принимаете условия&nbsp;<router-link to="/page/oferta/">Публичной оферты</router-link>
              </p>
              <div v-if="submitStatus.message && submitStatus.error" class="mc-message mc-message--alert">
                        <span class="mc-message__content" v-html="submitStatus.message">

                        </span>
              </div>
            </div>
            <div class="mc-form__bottom">
              <button class="mc-button mc-button--color simulated-hover" type="submit" :disabled="isSubmitting">
                <span class="mc-button__text">
                  {{ isSubmitting ? 'Отправка...' : 'Отправить' }}
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String, Number, Boolean],
      default: false
    }
  },
  emits: ['close'],
  data() {
    return {
      formData: {
        name: '',
        email: '',
        product_id: this.id
      },
      isSubmitting: false,
      submitStatus: {
        error: false,
        success: false,
        message: ''
      }
    };
  },
  mounted() {
    this.submitStatus = { error: false, success: false, message: '' };
  },
  watch: {
    id(newVal) {
      this.formData.productId = newVal;
    }
  },
  methods: {
    async submitForm() {
      this.isSubmitting = true;
      this.submitStatus = { error: false, success: false, message: '' };

      try {
        const response = await axios.post('api/catalog/waiting/add/', this.formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (response.data.status == 'success' && response.status === 200) {
          this.submitStatus.message = 'Заявка успешно отправлена!';
          this.formData.name = '';
          this.formData.email = '';
          this.submitStatus.success = true;

          // Close the modal after successful submission with a short delay
          /*setTimeout(() => {
            this.$emit('close');
          }, 2000);*/
        } else {
          this.submitStatus.error = true;
          for (let i in response.data.errors)
            this.submitStatus.message += response.data.errors[i].message+'<br>';
          //throw new Error('Произошла ошибка при отправке запроса');
        }
      } catch (error) {
        this.submitStatus.error = true;
        this.submitStatus.message = error.response?.data?.message ||
                                   'Произошла ошибка при отправке запроса. Пожалуйста, попробуйте позже.';
        console.error('Form submission error:', error);
      } finally {
        this.isSubmitting = false;
      }
    }
  }
}
</script>